import { motion } from 'motion/react';
import { Button } from './ui/button';
import { LucideIcon } from 'lucide-react';

interface CourseCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  index: number;
  url: string;
  actions?: React.ReactNode; // ← NEW: optional actions slot
}

export function CourseCard({ title, description, icon: Icon, index, url, actions }: CourseCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{
        y: -8,
        scale: 1.02,
      }}
      className="relative p-6 rounded-xl transition-all duration-300 group cursor-pointer"
      style={{
        background: 'rgba(15, 35, 60, 0.6)',
        border: '1px solid rgba(0, 229, 209, 0.2)',
      }}
    >
      <div
        className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        style={{
          background: 'rgba(0, 229, 209, 0.05)',
          boxShadow: '0 0 40px rgba(0, 229, 209, 0.3)',
        }}
      />

      <div className="relative z-10">
        <div
          className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center mb-4"
          style={{
            boxShadow: '0 0 20px rgba(0, 229, 209, 0.4)',
          }}
        >
          <Icon className="w-6 h-6 text-white" />
        </div>

        <h3 className="text-white mb-2">{title}</h3>
        <p className="text-cyan-200 mb-4 opacity-80">{description}</p>

        <div className="flex items-center justify-between mb-3">
          <span className="text-gray-400 text-sm">MindEngage Authoring Studio</span>
        </div>

        {actions ? (
          <div className="grid grid-cols-2 gap-2">
            {actions}
          </div>
        ) : (
          <Button
            className="w-full bg-transparent border border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-white transition-all duration-300"
            style={{
              boxShadow: '0 0 15px rgba(0, 229, 209, 0.2)',
            }}
            onClick={() => window.open(url, "_blank")}
          >
            Visit Course
          </Button>
        )}
      </div>
    </motion.div>
  );
}
